
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("19TnD", function(module, exports) {

$parcel$export(module.exports, "workerDefinitions", () => $582fff591ae20582$export$33b6275930f9bd71);
$parcel$export(module.exports, "workerNames", () => $582fff591ae20582$export$c8a09093152cd839);
$parcel$export(module.exports, "isSupportedWorkerName", () => $582fff591ae20582$export$468a4ad0ae64f44a);
$parcel$export(module.exports, "workerIframeCommandCandidateSchema", () => $582fff591ae20582$export$ede8252d79ab21d9);
$parcel$export(module.exports, "workerRelayReplacementCommandSchema", () => $582fff591ae20582$export$8bdb5c81567411db);
$parcel$export(module.exports, "workerRelayRestoredMessageSchema", () => $582fff591ae20582$export$b36186f50edeb78a);
$parcel$export(module.exports, "clientDisconnectCommandSchema", () => $582fff591ae20582$export$dc763b5bf8028cbd);
$parcel$export(module.exports, "getWorkerCommandSchema", () => $582fff591ae20582$export$f2a5a112b1b759);
$parcel$export(module.exports, "healthCheckWorkerPortResponseSchema", () => $582fff591ae20582$export$70ca44b5ac6f964a);
$parcel$export(module.exports, "websocketWorkerPortResponseSchema", () => $582fff591ae20582$export$169c812bd27080c4);
$parcel$export(module.exports, "appClientDisconnectTopic", () => $582fff591ae20582$export$e33ebfe7424dbf07);
$parcel$export(module.exports, "appMessageSchema", () => $582fff591ae20582$export$9f830074a0a0dde5);
$parcel$export(module.exports, "appWorkerReadyMessageSchema", () => $582fff591ae20582$export$85e1e5e22a729ebc);
$parcel$export(module.exports, "windowInitializeRequestSchema", () => $582fff591ae20582$export$e236590ba76a4833);
$parcel$export(module.exports, "windowInitializeResponseSchema", () => $582fff591ae20582$export$10228686b4538e2f);
$parcel$export(module.exports, "orderBlotterAddTabMessageSchema", () => $582fff591ae20582$export$4129133a619fc125);
$parcel$export(module.exports, "notificationMessageTypes", () => $582fff591ae20582$export$53ae21d0e64149e2);
$parcel$export(module.exports, "notificationPostMessageSchema", () => $582fff591ae20582$export$5ea5eea36ae96198);
/**
 * Defines the runtime-validated vocabulary shared by QEP preload window, iframe, and worker boundaries.
 * Schemas stay composable so boundary listeners can validate an envelope before selecting a payload parser.
 */ 
var $gH72i = parcelRequire("gH72i");
parcelRequire("8qhDq");
var $bS9P7 = parcelRequire("bS9P7");

var $6Ssjk = parcelRequire("6Ssjk");
const $582fff591ae20582$var$nonEmptyStringSchema = $gH72i.pipe($gH72i.string(), $gH72i.minLength(1));
const $582fff591ae20582$export$33b6275930f9bd71 = {
    healthCheck: 'healthcheck-worker',
    webSocket: 'web-socket-worker',
    mdsWebSocket: 'mds-ws-worker',
    oasWebSocket: 'oas-ws-worker'
};
const $582fff591ae20582$export$c8a09093152cd839 = Object.freeze(Object.keys($582fff591ae20582$export$33b6275930f9bd71));
const $582fff591ae20582$export$55ad036d1dfed4d9 = $gH72i.picklist($582fff591ae20582$export$c8a09093152cd839);
const $582fff591ae20582$var$supportedWorkerNames = new Set($582fff591ae20582$export$c8a09093152cd839);
const $582fff591ae20582$export$468a4ad0ae64f44a = (workerName)=>typeof workerName === 'string' && $582fff591ae20582$var$supportedWorkerNames.has(workerName);
const $582fff591ae20582$export$a27b220a6595d943 = {
    sessionIdUpdate: 'sessionIdUpdate',
    internalPong: 'internalPong',
    updateHealthCheck: 'updateHealthCheck',
    windowHealthCheck: 'windowHealthCheck',
    debugSubscriptionListResponse: 'DEBUG:SUBLIST:RESPONSE',
    clientDisconnect: 'clientDisconnect'
};
const $582fff591ae20582$export$390a1c6b2a08ad21 = {
    subscription: 'subscription',
    unsubscribe: 'unsubscribe',
    windowHealthCheck: 'windowHealthCheck',
    debugSubscriptionListResponse: 'DEBUG:SUBLIST:RESPONSE',
    dispose: 'dispose'
};
const $582fff591ae20582$var$reservedWorkerMessageTopics = new Set(Object.values($582fff591ae20582$export$a27b220a6595d943));
/** Rejects subscription topics that a worker dispatches as control commands before reading messageType. */ const $582fff591ae20582$var$isSubscriptionTopic = (topic)=>!$582fff591ae20582$var$reservedWorkerMessageTopics.has(topic);
const $582fff591ae20582$var$subscriptionTopicSchema = $gH72i.pipe($582fff591ae20582$var$nonEmptyStringSchema, $gH72i.check($582fff591ae20582$var$isSubscriptionTopic, 'Subscription topics cannot use reserved worker control topics.'));
const $582fff591ae20582$export$ede8252d79ab21d9 = $gH72i.object({
    workerName: $gH72i.string(),
    message: $gH72i.string()
});
const $582fff591ae20582$export$15345589fc932d2f = $gH72i.object({
    workerName: $582fff591ae20582$export$55ad036d1dfed4d9,
    message: $gH72i.string()
});
const $582fff591ae20582$export$8bdb5c81567411db = $gH72i.object({
    recoveryId: $582fff591ae20582$var$nonEmptyStringSchema,
    workerName: $582fff591ae20582$export$55ad036d1dfed4d9,
    type: $gH72i.literal('replaceWorkerRelay')
});
const $582fff591ae20582$export$dd30c00fbdb67df9 = $gH72i.object({
    workerName: $gH72i.string(),
    message: $gH72i.unknown()
});
const $582fff591ae20582$export$2d05a681c4abd096 = $gH72i.object({
    workerName: $582fff591ae20582$export$55ad036d1dfed4d9,
    message: $gH72i.unknown()
});
const $582fff591ae20582$export$b36186f50edeb78a = $gH72i.object({
    newRelayGeneration: $gH72i.optional($gH72i.pipe($gH72i.number(), $gH72i.integer(), $gH72i.minValue(1))),
    oldRelayGeneration: $gH72i.optional($gH72i.pipe($gH72i.number(), $gH72i.integer(), $gH72i.minValue(1))),
    recoveryId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema),
    type: $gH72i.literal('workerRelayRestored')
});
const $582fff591ae20582$export$cc59f7247f87d26 = $gH72i.object({
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.sessionIdUpdate),
    sessionId: $gH72i.optional($gH72i.string()),
    messageType: $gH72i.optional($gH72i.never())
});
const $582fff591ae20582$export$6b19c31bc034d351 = $gH72i.object({
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.sessionIdUpdate),
    sessionId: $582fff591ae20582$var$nonEmptyStringSchema
});
const $582fff591ae20582$export$ce8fd0f1bb7f8839 = $gH72i.object({
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.internalPong),
    messageType: $gH72i.optional($gH72i.never())
});
const $582fff591ae20582$export$9cfbca382e455238 = $gH72i.object({
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.updateHealthCheck),
    messageType: $gH72i.optional($gH72i.never())
});
const $582fff591ae20582$export$dc763b5bf8028cbd = $gH72i.object({
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.clientDisconnect),
    messageType: $gH72i.literal($582fff591ae20582$export$390a1c6b2a08ad21.dispose)
});
const $582fff591ae20582$export$3766bffc6b2c0bd4 = $gH72i.union([
    $582fff591ae20582$export$9cfbca382e455238,
    $582fff591ae20582$export$dc763b5bf8028cbd
]);
const $582fff591ae20582$export$46c29af42a661ca6 = $gH72i.object({
    replayStrategy: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema)
});
const $582fff591ae20582$export$57ef8defc88e9d71 = $gH72i.object({
    topic: $582fff591ae20582$var$nonEmptyStringSchema,
    data: $gH72i.optional($gH72i.unknown()),
    subscriptionOptions: $gH72i.optional($582fff591ae20582$export$46c29af42a661ca6)
});
const $582fff591ae20582$var$subscriptionControlBase = {
    topicUniqueId: $582fff591ae20582$var$nonEmptyStringSchema,
    topic: $582fff591ae20582$var$subscriptionTopicSchema,
    data: $gH72i.optional($gH72i.unknown()),
    subscriptionOptions: $gH72i.optional($582fff591ae20582$export$46c29af42a661ca6),
    requestId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema)
};
const $582fff591ae20582$export$fe34e49db44d29d5 = $gH72i.object({
    ...$582fff591ae20582$var$subscriptionControlBase,
    recoveryId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema),
    messageType: $gH72i.literal($582fff591ae20582$export$390a1c6b2a08ad21.subscription)
});
const $582fff591ae20582$export$efbfdadc03f35393 = $gH72i.object({
    ...$582fff591ae20582$var$subscriptionControlBase,
    messageType: $gH72i.literal($582fff591ae20582$export$390a1c6b2a08ad21.unsubscribe)
});
const $582fff591ae20582$export$334935c480a99905 = $gH72i.object({
    topicUniqueId: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.windowHealthCheck),
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.windowHealthCheck),
    messageType: $gH72i.literal($582fff591ae20582$export$390a1c6b2a08ad21.windowHealthCheck),
    data: $gH72i.record($582fff591ae20582$var$nonEmptyStringSchema, $582fff591ae20582$export$57ef8defc88e9d71)
});
const $582fff591ae20582$export$98390aac10afc1b = $gH72i.object({
    topicUniqueId: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.debugSubscriptionListResponse),
    topic: $gH72i.literal($582fff591ae20582$export$a27b220a6595d943.debugSubscriptionListResponse),
    messageType: $gH72i.literal($582fff591ae20582$export$390a1c6b2a08ad21.debugSubscriptionListResponse),
    data: $gH72i.object({
        meta: $gH72i.optional($gH72i.unknown()),
        subscriptions: $gH72i.array($gH72i.unknown())
    })
});
const $582fff591ae20582$export$960662b25ee0cb5d = $gH72i.union([
    $582fff591ae20582$export$dc763b5bf8028cbd,
    $582fff591ae20582$export$cc59f7247f87d26,
    $582fff591ae20582$export$ce8fd0f1bb7f8839,
    $582fff591ae20582$export$fe34e49db44d29d5,
    $582fff591ae20582$export$efbfdadc03f35393,
    $582fff591ae20582$export$334935c480a99905,
    $582fff591ae20582$export$98390aac10afc1b
]);
function $582fff591ae20582$export$f2a5a112b1b759(workerName) {
    return workerName === 'healthCheck' ? $582fff591ae20582$export$3766bffc6b2c0bd4 : $582fff591ae20582$export$960662b25ee0cb5d;
}
const $582fff591ae20582$export$32f4ce4cbc2e3ffb = $gH72i.union([
    $582fff591ae20582$export$3766bffc6b2c0bd4,
    $582fff591ae20582$export$960662b25ee0cb5d
]);
const $582fff591ae20582$export$7b6da5a2ef1811bc = $gH72i.object({
    topic: $582fff591ae20582$var$nonEmptyStringSchema,
    messageType: $gH72i.picklist([
        $582fff591ae20582$export$390a1c6b2a08ad21.subscription,
        $582fff591ae20582$export$390a1c6b2a08ad21.unsubscribe
    ]),
    data: $gH72i.unknown(),
    requestId: $582fff591ae20582$var$nonEmptyStringSchema
});
const $582fff591ae20582$export$16c702ad6dfedf80 = $gH72i.object({
    requestId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema),
    responseType: $gH72i.optional($gH72i.string()),
    topic: $gH72i.optional($gH72i.string()),
    topicUniqueId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema),
    payload: $gH72i.unknown()
});
const $582fff591ae20582$export$ef47ffd6ff9c7c28 = $gH72i.object({
    topic: $gH72i.literal('clientSubscriptions'),
    requestId: $582fff591ae20582$var$nonEmptyStringSchema
});
const $582fff591ae20582$export$41e0d1a2cef4ab95 = $gH72i.object({
    topic: $gH72i.literal('DEBUG:SUBLIST:REQUEST'),
    meta: $gH72i.optional($gH72i.unknown())
});
const $582fff591ae20582$export$e8a5045cf0a5e13a = $gH72i.union([
    $582fff591ae20582$export$ef47ffd6ff9c7c28,
    $582fff591ae20582$export$41e0d1a2cef4ab95
]);
const $582fff591ae20582$export$b4b8babba33759c3 = $gH72i.object({
    lastHeartbeatUtc: $gH72i.string(),
    statusInfo: $gH72i.enum((0, $bS9P7.HasiStatus)),
    statusInfoString: $gH72i.string(),
    componentName: $gH72i.string(),
    dependencies: $gH72i.optional($gH72i.array($gH72i.unknown()))
});
const $582fff591ae20582$export$70ca44b5ac6f964a = $gH72i.array($582fff591ae20582$export$b4b8babba33759c3);
const $582fff591ae20582$export$1ebc268a8853cdb1 = $gH72i.object({
    type: $gH72i.literal('healthcheck'),
    topicUniqueId: $gH72i.picklist([
        'healthcheck',
        'connected'
    ]),
    message: $gH72i.object({
        error: $gH72i.null(),
        payload: $gH72i.picklist([
            'ping',
            'connected'
        ]),
        topicUniqueId: $gH72i.picklist([
            'healthcheck',
            'connected'
        ])
    })
});
const $582fff591ae20582$export$f3d2c2ac97d9d5dc = $gH72i.object({
    type: $gH72i.literal('wsmessage'),
    topicUniqueId: $gH72i.optional($582fff591ae20582$var$nonEmptyStringSchema),
    message: $gH72i.unknown()
});
const $582fff591ae20582$export$169c812bd27080c4 = $gH72i.union([
    $582fff591ae20582$export$1ebc268a8853cdb1,
    $582fff591ae20582$export$f3d2c2ac97d9d5dc
]);
const $582fff591ae20582$export$b69892ed034bf7bb = $gH72i.union([
    $582fff591ae20582$export$70ca44b5ac6f964a,
    $582fff591ae20582$export$169c812bd27080c4
]);
const $582fff591ae20582$export$e75eebdeb1981458 = {
    publish: 'publish',
    subscribe: 'subscribe',
    request: 'request',
    response: 'response',
    broadcast: 'broadCast'
};
const $582fff591ae20582$export$e33ebfe7424dbf07 = 'client_disconnect';
const $582fff591ae20582$var$appRequestMetaSchema = $gH72i.object({
    requestId: $582fff591ae20582$var$nonEmptyStringSchema
});
const $582fff591ae20582$var$appMessageBase = {
    topic: $582fff591ae20582$var$nonEmptyStringSchema,
    message: $gH72i.unknown(),
    sender: $gH72i.optional($gH72i.string())
};
const $582fff591ae20582$export$10d4dd954097f2ea = $gH72i.object({
    ...$582fff591ae20582$var$appMessageBase,
    messageType: $gH72i.literal($582fff591ae20582$export$e75eebdeb1981458.request),
    meta: $582fff591ae20582$var$appRequestMetaSchema
});
const $582fff591ae20582$export$deae83eb6558844a = $gH72i.object({
    ...$582fff591ae20582$var$appMessageBase,
    messageType: $gH72i.literal($582fff591ae20582$export$e75eebdeb1981458.response),
    meta: $582fff591ae20582$var$appRequestMetaSchema
});
const $582fff591ae20582$export$7e1cf19c43491547 = $gH72i.object({
    ...$582fff591ae20582$var$appMessageBase,
    messageType: $gH72i.literal($582fff591ae20582$export$e75eebdeb1981458.publish),
    meta: $gH72i.optional($582fff591ae20582$var$appRequestMetaSchema)
});
const $582fff591ae20582$export$39d7a930756bb31d = $gH72i.object({
    ...$582fff591ae20582$var$appMessageBase,
    messageType: $gH72i.literal($582fff591ae20582$export$e75eebdeb1981458.subscribe),
    meta: $gH72i.optional($582fff591ae20582$var$appRequestMetaSchema)
});
const $582fff591ae20582$export$160dfd89061498ad = $gH72i.object({
    ...$582fff591ae20582$var$appMessageBase,
    messageType: $gH72i.literal($582fff591ae20582$export$e75eebdeb1981458.broadcast),
    meta: $gH72i.optional($582fff591ae20582$var$appRequestMetaSchema)
});
const $582fff591ae20582$export$9f830074a0a0dde5 = $gH72i.variant('messageType', [
    $582fff591ae20582$export$10d4dd954097f2ea,
    $582fff591ae20582$export$deae83eb6558844a,
    $582fff591ae20582$export$7e1cf19c43491547,
    $582fff591ae20582$export$39d7a930756bb31d,
    $582fff591ae20582$export$160dfd89061498ad
]);
const $582fff591ae20582$export$9cd2d342a99d30a8 = {
    windowInitialize: 'window_initialize'
};
const $582fff591ae20582$export$85e1e5e22a729ebc = $gH72i.object({
    workerLoaded: $gH72i.literal(true)
});
const $582fff591ae20582$export$e236590ba76a4833 = $gH72i.object({
    type: $gH72i.literal($582fff591ae20582$export$9cd2d342a99d30a8.windowInitialize)
});
const $582fff591ae20582$export$9c69c24c98470a5f = $gH72i.object({
    apiServer: $gH72i.string(),
    appEnv: $gH72i.string(),
    fileServer: $gH72i.string(),
    previewMode: $gH72i.string(),
    webSocketServer: $gH72i.string(),
    mdsWsServer: $gH72i.string(),
    oasWsServer: $gH72i.string()
});
const $582fff591ae20582$export$10228686b4538e2f = $gH72i.object({
    type: $gH72i.literal($582fff591ae20582$export$9cd2d342a99d30a8.windowInitialize),
    browserContextId: $582fff591ae20582$var$nonEmptyStringSchema,
    spawnDataId: $gH72i.nullable($gH72i.string()),
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Preserve the established cross-window wire field.
    windowID: $gH72i.nullable($gH72i.string()),
    componentId: $gH72i.nullable($gH72i.string()),
    runtimeConfig: $582fff591ae20582$export$9c69c24c98470a5f
});
const $582fff591ae20582$export$4129133a619fc125 = $gH72i.object({
    type: $gH72i.literal('order_blotter_add_internal_tab')
});
const $582fff591ae20582$export$53ae21d0e64149e2 = {
    notification: 'qep.notification',
    localToast: 'qep.notification.local.toast',
    localDismiss: 'qep.notification.local.dismiss'
};
const $582fff591ae20582$export$7ec89e24d15f2687 = [
    'error',
    'success',
    'warning',
    'info'
];
const $582fff591ae20582$export$b74e97a563a25fe1 = $gH72i.object({
    type: $gH72i.literal($582fff591ae20582$export$53ae21d0e64149e2.notification),
    data: (0, $6Ssjk.QEPNotificationPayloadSchema)
});
const $582fff591ae20582$export$33856b475910ab57 = $gH72i.object({
    type: $gH72i.literal($582fff591ae20582$export$53ae21d0e64149e2.localToast),
    data: $gH72i.object({
        id: $582fff591ae20582$var$nonEmptyStringSchema,
        method: $gH72i.picklist($582fff591ae20582$export$7ec89e24d15f2687),
        title: $582fff591ae20582$var$nonEmptyStringSchema
    })
});
const $582fff591ae20582$export$d9b031948d71ebff = $gH72i.object({
    type: $gH72i.literal($582fff591ae20582$export$53ae21d0e64149e2.localDismiss),
    data: $gH72i.object({
        id: $582fff591ae20582$var$nonEmptyStringSchema
    })
});
const $582fff591ae20582$export$5ea5eea36ae96198 = $gH72i.variant('type', [
    $582fff591ae20582$export$b74e97a563a25fe1,
    $582fff591ae20582$export$33856b475910ab57,
    $582fff591ae20582$export$d9b031948d71ebff
]);

});
parcelRegister("8qhDq", function(module, exports) {

$parcel$export(module.exports, "HasiStatus", () => (parcelRequire("bS9P7")).HasiStatus);

var $bS9P7 = parcelRequire("bS9P7");

var $gH72i = parcelRequire("gH72i");
// src/util/delay.ts
async function $621e6e58f408692c$export$1391212d75b2ee65(ms) {
    await new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
// src/util/lazy-map.ts
var $621e6e58f408692c$export$6a8d730ca5a4eb4d = class extends Map {
    #factory;
    constructor(factory){
        super();
        this.#factory = factory;
    }
    get(key) {
        if (!this.has(key)) this.set(key, this.#factory(key));
        return super.get(key);
    }
};
// src/util/date.ts
function $621e6e58f408692c$export$b0327f3657913504() {
    const now = /* @__PURE__ */ new Date();
    const offset = now.getTimezoneOffset();
    return new Date(now.getTime() - offset * 60000).toISOString().split("T")[0];
}
function $621e6e58f408692c$export$a220d017f73f6afe(date) {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}
var $621e6e58f408692c$var$hoursRegex = /^\d{2}:\d{2}:\d{2}$/;
function $621e6e58f408692c$export$a5787b6c5e65f15f(hours) {
    if (!$621e6e58f408692c$var$hoursRegex.test(hours)) throw new Error('Expected format "HH:MM:SS"');
    const offset = $621e6e58f408692c$export$22d85042c308f25c(/* @__PURE__ */ new Date()) ? "-0400" : "-0500";
    return /* @__PURE__ */ new Date(`${$621e6e58f408692c$export$b0327f3657913504()}T${hours}${offset}`);
}
function $621e6e58f408692c$export$22d85042c308f25c(date) {
    return !$621e6e58f408692c$var$isBeforeSecondSundayOfMarch(date) && $621e6e58f408692c$var$isBeforeFirstSundayOfNovember(date);
}
function $621e6e58f408692c$var$isBeforeSecondSundayOfMarch(date) {
    const year = date.getFullYear();
    const marchFirst = new Date(year, 2, 1);
    const dayOfWeek = marchFirst.getDay();
    const firstSunday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
    const secondSunday = firstSunday + 7;
    const secondSundayDate = new Date(year, 2, secondSunday);
    return date < secondSundayDate;
}
function $621e6e58f408692c$var$isBeforeFirstSundayOfNovember(date) {
    const year = date.getFullYear();
    const novFirst = new Date(year, 10, 1);
    const dayOfWeek = novFirst.getDay();
    const firstSunday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
    const firstSundayDate = new Date(year, 10, firstSunday);
    return date < firstSundayDate;
}
// src/oas.ts
var $621e6e58f408692c$export$874299d66475ce82 = /* @__PURE__ */ ((OasAction2)=>{
    OasAction2["Error"] = "ERROR";
    OasAction2["OptionAnalyticsSubscribe"] = "OptionAnalytics/Subscribe";
    OasAction2["OptionAnalyticsSubscribeAck"] = "OptionAnalytics/Subscribe/Ack";
    OasAction2["OptionAnalyticsUnsubscribe"] = "OptionAnalytics/Unsubscribe";
    OasAction2["OptionAnalyticsUnsubscribeAck"] = "OptionAnalytics/Unsubscribe/Ack";
    OasAction2["OptionAnalyticsData"] = "OptionAnalytics/Data";
    OasAction2["StrikeSeriesSubscribe"] = "StrikeSeries/Subscribe";
    OasAction2["StrikeSeriesSubscribeAck"] = "StrikeSeries/Subscribe/Ack";
    OasAction2["StrikeSeriesUnsubscribe"] = "StrikeSeries/Unsubscribe";
    OasAction2["StrikeSeriesUnsubscribeAck"] = "StrikeSeries/Unsubscribe/Ack";
    OasAction2["StrikeSeriesData"] = "StrikeSeries/Data";
    OasAction2["VolCurveSubscribe"] = "VolCurve/Subscribe";
    OasAction2["VolCurveSubscribeAck"] = "VolCurve/Subscribe/Ack";
    OasAction2["VolCurveUnsubscribe"] = "VolCurve/Unsubscribe";
    OasAction2["VolCurveUnsubscribeAck"] = "VolCurve/Unsubscribe/Ack";
    OasAction2["VolCurveData"] = "VolCurve/Data";
    return OasAction2;
})($621e6e58f408692c$export$874299d66475ce82 || {});
// src/inventory.ts
var $621e6e58f408692c$export$b448cf21ca5574b1 = /* @__PURE__ */ ((InventoryAction2)=>{
    InventoryAction2["Error"] = "Inventory/Error";
    InventoryAction2["Subscribe"] = "Inventory/Subscribe";
    InventoryAction2["SubscribeAck"] = "Inventory/Subscribe/Ack";
    InventoryAction2["Unsubscribe"] = "Inventory/Unsubscribe";
    InventoryAction2["UnsubscribeAck"] = "Inventory/Unsubscribe/Ack";
    InventoryAction2["Reset"] = "Inventory/Reset";
    InventoryAction2["Data"] = "Inventory/Data";
    return InventoryAction2;
})($621e6e58f408692c$export$b448cf21ca5574b1 || {});
var $621e6e58f408692c$export$9cc3fd3c6a8212d7 = $gH72i.union([
    $gH72i.literal("critical"),
    $gH72i.literal("informative")
]);
var $621e6e58f408692c$export$ed9439f4ec7e0a1d = $gH72i.object({
    id: $gH72i.string(),
    level: $621e6e58f408692c$export$9cc3fd3c6a8212d7,
    title: $gH72i.string(),
    message: $gH72i.string(),
    actions: $gH72i.optional($gH72i.array($gH72i.object({
        label: $gH72i.string(),
        href: $gH72i.string()
    })))
});
var $621e6e58f408692c$export$98789bf6b3640f79 = $gH72i.object({
    type: $gH72i.literal("activate-system-notification"),
    payload: $621e6e58f408692c$export$ed9439f4ec7e0a1d
});
var $621e6e58f408692c$export$6bdd34db78a4d3ef = $gH72i.object({
    type: $gH72i.literal("deactivate-system-notification"),
    payload: $gH72i.string()
});
var $621e6e58f408692c$export$20e0daf378dd3f0e = $gH72i.object({
    type: $gH72i.literal("set-system-notifications"),
    payload: $gH72i.array($621e6e58f408692c$export$ed9439f4ec7e0a1d)
});
var $621e6e58f408692c$export$8d2f2c0b1e8b06c1 = $gH72i.variant("type", [
    $621e6e58f408692c$export$98789bf6b3640f79,
    $621e6e58f408692c$export$6bdd34db78a4d3ef,
    $621e6e58f408692c$export$20e0daf378dd3f0e
]);

});
parcelRegister("bS9P7", function(module, exports) {

$parcel$export(module.exports, "HasiStatus", () => $8a4c5b9713391eef$export$a764cc3c75b81d5e);
// src/util/delegate.ts
function $8a4c5b9713391eef$export$10b1921597150314() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}
// src/util/error-to-string.ts
function $8a4c5b9713391eef$export$46c1952d522542d7(value) {
    if (value instanceof Error) return value.stack ?? value.message ?? JSON.stringify(value);
    return JSON.stringify(value);
}
// src/hasi.ts
var $8a4c5b9713391eef$export$a764cc3c75b81d5e = /* @__PURE__ */ ((HasiStatus2)=>{
    HasiStatus2["HASISTATUS_NOTSET"] = "HASISTATUS_NOTSET";
    HasiStatus2["HASISTATUS_OK"] = "HASISTATUS_OK";
    HasiStatus2["HASISTATUS_START_REQUESTED"] = "HASISTATUS_START_REQUESTED";
    HasiStatus2["HASISTATUS_INITIALIZING"] = "HASISTATUS_INITIALIZING";
    HasiStatus2["HASISTATUS_INITIALIZED"] = "HASISTATUS_INITIALIZED";
    HasiStatus2["HASISTATUS_VALIDATING"] = "HASISTATUS_VALIDATING";
    HasiStatus2["HASISTATUS_INVALID"] = "HASISTATUS_INVALID";
    HasiStatus2["HASISTATUS_RUNNING"] = "HASISTATUS_RUNNING";
    HasiStatus2["HASISTATUS_RUNNING_WITH_ERRORS"] = "HASISTATUS_RUNNING_WITH_ERRORS";
    HasiStatus2["HASISTATUS_COMPLETE"] = "HASISTATUS_COMPLETE";
    HasiStatus2["HASISTATUS_STOP_REQUESTED"] = "HASISTATUS_STOP_REQUESTED";
    HasiStatus2["HASISTATUS_FORCE_STOP_REQUESTED"] = "HASISTATUS_FORCE_STOP_REQUESTED";
    HasiStatus2["HASISTATUS_STOPPED"] = "HASISTATUS_STOPPED";
    HasiStatus2["HASISTATUS_ABORTED"] = "HASISTATUS_ABORTED";
    HasiStatus2["HASISTATUS_INTERNAL_ERROR"] = "HASISTATUS_INTERNAL_ERROR";
    HasiStatus2["HASISTATUS_EXTERNAL_ERROR"] = "HASISTATUS_EXTERNAL_ERROR";
    HasiStatus2["HASISTATUS_FATAL_ERROR"] = "HASISTATUS_FATAL_ERROR";
    HasiStatus2["HASISTATUS_OTHER"] = "HASISTATUS_OTHER";
    return HasiStatus2;
})($8a4c5b9713391eef$export$a764cc3c75b81d5e || {});

});


parcelRegister("6Ssjk", function(module, exports) {

$parcel$export(module.exports, "QEPNotificationPayloadSchema", () => $358c7279995e0234$export$d72850b082d2e31a);

var $gH72i = parcelRequire("gH72i");

var $cckdX = parcelRequire("cckdX");
const $358c7279995e0234$export$cb64b2c5cff7701a = $gH72i.pipe($gH72i.string(), $gH72i.regex(/^<div class="custom-noty"/i, 'Returned value is not an html string'));
const $358c7279995e0234$export$21ba0739a0fdc637 = $gH72i.enum((0, $cckdX.QEPNotificationType), 'Invalid notification type');
const $358c7279995e0234$export$7a449a79ad51077b = $gH72i.enum((0, $cckdX.QEPNotificationStatus), 'Invalid notification status');
const $358c7279995e0234$export$e97d7d9796cd248d = $gH72i.enum((0, $cckdX.QEPNotificationLocation), 'Invalid notification location');
const $358c7279995e0234$export$d72850b082d2e31a = $gH72i.object({
    id: $gH72i.optional($gH72i.nullable($gH72i.string())),
    title: $gH72i.string(),
    shortDescription: $gH72i.optional($gH72i.nullable($gH72i.string())),
    longDescription: $gH72i.optional($gH72i.nullable($gH72i.string())),
    type: $358c7279995e0234$export$21ba0739a0fdc637,
    status: $gH72i.optional($gH72i.nullable($358c7279995e0234$export$7a449a79ad51077b)),
    timestamp: $gH72i.optional($gH72i.nullable($gH72i.string())),
    payload: $gH72i.optional($gH72i.nullable($gH72i.any())),
    location: $gH72i.optional($gH72i.nullable($358c7279995e0234$export$e97d7d9796cd248d))
});
const $358c7279995e0234$export$e9f2344966fdb681 = $gH72i.object({
    type: $gH72i.optional($gH72i.nullable($gH72i.picklist([
        'alert',
        'success',
        'warning',
        'error',
        'info',
        'information'
    ]))),
    layout: $gH72i.optional($gH72i.nullable($gH72i.picklist([
        'top',
        'topLeft',
        'topCenter',
        'topRight',
        'center',
        'centerLeft',
        'centerRight',
        'bottom',
        'bottomLeft',
        'bottomCenter',
        'bottomRight'
    ]))),
    theme: $gH72i.optional($gH72i.nullable($gH72i.picklist([
        'mint',
        'sunset',
        'relax',
        'metroui',
        'bootstrap-v3',
        'bootstrap-v4',
        'semanticui',
        'nest'
    ]))),
    text: $gH72i.optional($gH72i.nullable($gH72i.string())),
    timeout: $gH72i.optional($gH72i.nullable($gH72i.union([
        $gH72i.number(),
        $gH72i.literal(false)
    ]))),
    progressBar: $gH72i.optional($gH72i.nullable($gH72i.boolean())),
    closeWith: $gH72i.optional($gH72i.nullable($gH72i.array($gH72i.picklist([
        'click',
        'button'
    ])))),
    animation: $gH72i.optional($gH72i.nullable($gH72i.object({
        open: $gH72i.optional($gH72i.nullable($gH72i.union([
            $gH72i.string(),
            $gH72i.function()
        ]))),
        close: $gH72i.optional($gH72i.nullable($gH72i.union([
            $gH72i.string(),
            $gH72i.function()
        ])))
    }))),
    id: $gH72i.optional($gH72i.nullable($gH72i.union([
        $gH72i.string(),
        $gH72i.literal(false)
    ]))),
    force: $gH72i.optional($gH72i.nullable($gH72i.boolean())),
    killer: $gH72i.optional($gH72i.nullable($gH72i.union([
        $gH72i.string(),
        $gH72i.boolean()
    ]))),
    queue: $gH72i.optional($gH72i.nullable($gH72i.string())),
    container: $gH72i.optional($gH72i.nullable($gH72i.union([
        $gH72i.string(),
        $gH72i.literal(false)
    ]))),
    buttons: $gH72i.optional($gH72i.nullable($gH72i.array($gH72i.object({
        text: $gH72i.string(),
        classNames: $gH72i.string(),
        cb: $gH72i.function(),
        attributes: $gH72i.any()
    })))),
    callbacks: $gH72i.optional($gH72i.nullable($gH72i.object({
        beforeShow: $gH72i.optional($gH72i.nullable($gH72i.function())),
        onShow: $gH72i.optional($gH72i.nullable($gH72i.function())),
        afterShow: $gH72i.optional($gH72i.nullable($gH72i.function())),
        onClose: $gH72i.optional($gH72i.nullable($gH72i.function())),
        afterClose: $gH72i.optional($gH72i.nullable($gH72i.function())),
        onHover: $gH72i.optional($gH72i.nullable($gH72i.function())),
        onTemplate: $gH72i.optional($gH72i.nullable($gH72i.function()))
    }))),
    sounds: $gH72i.optional($gH72i.nullable($gH72i.object({
        sources: $gH72i.optional($gH72i.nullable($gH72i.array($gH72i.string()))),
        volume: $gH72i.optional($gH72i.nullable($gH72i.number())),
        conditions: $gH72i.optional($gH72i.nullable($gH72i.array($gH72i.string())))
    }))),
    docTitle: $gH72i.optional($gH72i.nullable($gH72i.object({
        conditions: $gH72i.optional($gH72i.nullable($gH72i.array($gH72i.string())))
    }))),
    modal: $gH72i.optional($gH72i.nullable($gH72i.boolean()))
});
const $358c7279995e0234$export$1f2fbe50c0552d40 = $gH72i.object({
    type: $358c7279995e0234$export$21ba0739a0fdc637,
    title: $gH72i.string(),
    shortDescription: $gH72i.string(),
    location: $358c7279995e0234$export$e97d7d9796cd248d
});
const $358c7279995e0234$export$d2c18dd14ce6bf29 = $gH72i.union([
    $358c7279995e0234$export$e9f2344966fdb681,
    $358c7279995e0234$export$1f2fbe50c0552d40
]);

});


parcelRegister("evEIS", function(module, exports) {

$parcel$export(module.exports, "resolveHttpOrigin", () => $4d9ae9d35fd9fe88$export$fa6f18a96f17ca74);
$parcel$export(module.exports, "resolveTrustedFrontendOrigins", () => $4d9ae9d35fd9fe88$export$7f8a056581a75cce);
$parcel$export(module.exports, "resolveParentMessageOrigin", () => $4d9ae9d35fd9fe88$export$b3cae1a40fb3b571);
$parcel$export(module.exports, "isTrustedMessageEvent", () => $4d9ae9d35fd9fe88$export$b6bb2e3776ddef71);
$parcel$export(module.exports, "decodeMessageData", () => $4d9ae9d35fd9fe88$export$88f290813edaa70d);
$parcel$export(module.exports, "logRejectedMessage", () => $4d9ae9d35fd9fe88$export$543e9f9718a59840);
/**
 * Provides shared fail-closed source, origin, decoding, and diagnostic helpers for runtime message boundaries.
 * Callers still select the boundary-specific Valibot schema after decoding succeeds.
 */ 
var $l2Ecb = parcelRequire("l2Ecb");
const $4d9ae9d35fd9fe88$var$trustedAppSubdomainLabels = [
    'algomanager',
    'audit',
    'blotter',
    'charting',
    'inventory',
    'monitoring',
    'newoptions',
    'options',
    'order-entry',
    'orderbook',
    'orderentry',
    'ordersummary',
    'tickergrid'
];
const $4d9ae9d35fd9fe88$export$fa6f18a96f17ca74 = (value, baseUrl = globalThis.location?.href)=>{
    try {
        const url = new URL(value, baseUrl);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
        return url.origin;
    } catch  {
        return undefined;
    }
};
/** Resolves only absolute HTTP(S) origins for values used as authorization roots. */ const $4d9ae9d35fd9fe88$var$resolveAbsoluteHttpOrigin = (value)=>{
    try {
        const url = new URL(value);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
        return url.origin;
    } catch  {
        return undefined;
    }
};
const $4d9ae9d35fd9fe88$export$7f8a056581a75cce = (fileServer, currentOrigin)=>{
    const fileServerOrigin = $4d9ae9d35fd9fe88$var$resolveAbsoluteHttpOrigin(fileServer);
    const pageOrigin = $4d9ae9d35fd9fe88$var$resolveAbsoluteHttpOrigin(currentOrigin);
    if (!fileServerOrigin || !pageOrigin) return new Set();
    const fileServerUrl = new URL(fileServerOrigin);
    const origins = new Set([
        fileServerOrigin
    ]);
    for (const subdomainLabel of $4d9ae9d35fd9fe88$var$trustedAppSubdomainLabels){
        const componentUrl = new URL(fileServerOrigin);
        componentUrl.hostname = `${subdomainLabel}.app.${fileServerUrl.hostname}`;
        origins.add(componentUrl.origin);
    }
    return origins.has(pageOrigin) ? origins : new Set();
};
const $4d9ae9d35fd9fe88$export$b3cae1a40fb3b571 = ({ appEnv: appEnv, currentOrigin: currentOrigin = globalThis.location?.origin ?? '', fileServer: fileServer = (0, $l2Ecb.getFileServer)(), referrer: referrer = globalThis.document?.referrer ?? '' } = {})=>{
    const referrerOrigin = referrer ? $4d9ae9d35fd9fe88$var$resolveAbsoluteHttpOrigin(referrer) : undefined;
    const trustedFrontendOrigins = $4d9ae9d35fd9fe88$export$7f8a056581a75cce(fileServer, currentOrigin);
    if (referrerOrigin && trustedFrontendOrigins.has(referrerOrigin)) return referrerOrigin;
    // Authentication test opt-in must not broaden parent-origin trust in deployed UAT.
    const allowsSameOriginFallback = [
        'local',
        'development'
    ].includes(appEnv ?? (0, $l2Ecb.getAppEnv)());
    if (!allowsSameOriginFallback) return undefined;
    return $4d9ae9d35fd9fe88$var$resolveAbsoluteHttpOrigin(currentOrigin);
};
const $4d9ae9d35fd9fe88$export$b6bb2e3776ddef71 = (event, expectedSource, allowedOrigins)=>event.source === expectedSource && allowedOrigins.has(event.origin);
const $4d9ae9d35fd9fe88$export$88f290813edaa70d = (data)=>{
    if (typeof data !== 'string') return {
        success: true,
        output: data
    };
    try {
        return {
            success: true,
            output: JSON.parse(data)
        };
    } catch  {
        return {
            success: false
        };
    }
};
const $4d9ae9d35fd9fe88$export$543e9f9718a59840 = (boundary, issues = [])=>{
    console.error('Rejected runtime message', {
        boundary: boundary,
        issueCount: issues.length
    });
};

});


//# sourceMappingURL=index.f2ad65e5.js.map
